import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import FloatingCta from './components/FloatingCta';

import Forside from './pages/Forside';
import Bostotte from './pages/Bostotte';
import Aflastning from './pages/Aflastning';
import AkutAnbringelse from './pages/AkutAnbringelse';
import BlivVikar from './pages/BlivVikar';
import Kontakt from './pages/Kontakt';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-white text-slate-900 font-sans selection:bg-amber-100 selection:text-amber-900">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/bostotte" element={<Bostotte />} />
            <Route path="/bostoette" element={<Bostotte />} />
            <Route path="/aflastning" element={<Aflastning />} />
            <Route path="/akut-anbringelse" element={<AkutAnbringelse />} />
            <Route path="/bliv-vikar" element={<BlivVikar />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCta />
      </div>
    </>
  );
}
